import React from "react";
import PropTypes from "prop-types";
import Label from "../Label";
import { labelTipoDte } from "./documentoDte";

// Chip visual del tipo de documento tributario de una fila (Factura / Nota de
// crédito / Nota de débito), derivado de `tipoDte`. Puramente presentacional.
const colorPorTipoDte = (tipoDte) => {
  switch (Number(tipoDte)) {
    case 61:
      return "warning"; // Nota de crédito
    case 56:
      return "info"; // Nota de débito
    default:
      return "default"; // Factura
  }
};

const TipoDocumentoChip = ({ tipoDte }) => (
  <Label variant="ghost" color={colorPorTipoDte(tipoDte)}>
    {labelTipoDte(tipoDte)}
  </Label>
);

TipoDocumentoChip.propTypes = {
  tipoDte: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
};

export default TipoDocumentoChip;
